export let language_en = {
  translation: {
    language: "Language",
    home: {
      helloWorld: "Hello world !",
      seeDetails: "See details",
      detail: "Home details...",
    },
    menu: {},
  },
};
